import { useParams } from "react-router-dom";
import { BaasAccountDetailPanel } from "./components/BaasAccountDetailPanel";

/**
 * Route wrapper: `/baas/contas/:accountId[/limites|/conta]`.
 * Shared UI lives in BaasAccountDetailPanel (also embedded on Root).
 */
export const BaasAccountDetailPage = () => {
  const { accountId } = useParams();
  return <BaasAccountDetailPanel accountId={accountId} />;
};

export default BaasAccountDetailPage;
